exports.$controller = function($seo) {
    const title = 'Magic Link Verification';
    $seo.set(title);
  };

exports.$inject = ['$seo'];
